import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = {
  key: 0,
  class: "login__error"
}
const _hoisted_3 = { class: "login__form" }
const _hoisted_4 = { class: "login__actions" }
const _hoisted_5 = {
  key: 0,
  class: "button__loading"
}
const _hoisted_6 = {
  key: 1,
  class: "button__text"
}

import { ref } from 'vue';

import { useForm } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import * as zod from 'zod';

import InputField from '../fields/InputField.vue';
import { ActionLogin } from '../../api/login/actionLogin';
import { GetSitedata } from '../../api/site/getSitedata';

import { useSiteStore } from '../../stores/siteStore';
import { useShopStore } from '../../stores/shopStore';

export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const siteStore = useSiteStore();

const shopStore = useShopStore();

const emit = __emit;

const isLoading = ref(false);
const isValidating = ref(false);
const craftError = ref('');

const { values, handleSubmit } = useForm({
  validationSchema: toTypedSchema(
    zod.object({
      email: zod.string().email('Ugyldig E-mail adresse'),
      password: zod
        .string()
        .min(6, 'Skal indeholde minimum 6 karakterer')
        .optional(),
    })
  ),
  initialValues: {
    email: '',
    password: '',
  },
});

const submit = handleSubmit(success, () => {
  isValidating.value = true;
});
async function success(values: any) {
  isLoading.value = true;
  craftError.value = '';
  const response = await ActionLogin(values.email, values.password);

  if (response.data.errorCode) {
    craftError.value = response.data.message;
    return;
  }

  const sitedata = await GetSitedata();
  if (sitedata.data.success) {
    siteStore.$patch({
      csrf: sitedata.data.csrf,
      account: sitedata.data.account,
      favorite: sitedata.data.favorite,
    });

    shopStore.$patch({
      cart: sitedata.data.cart,
    });
  }

  isLoading.value = false;
  emit('success');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (craftError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(craftError.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", _hoisted_3, [
      _createVNode(InputField, {
        name: "email",
        label: "E-mail",
        type: "email",
        autocomplete: "email",
        validate: isValidating.value
      }, null, 8, ["validate"]),
      _createVNode(InputField, {
        name: "password",
        label: "Adgangskode",
        type: "password",
        autocomplete: "current-password",
        validate: isValidating.value
      }, null, 8, ["validate"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)))
      }, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "loader" }, [
                _createElementVNode("div"),
                _createElementVNode("div"),
                _createElementVNode("div")
              ], -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[2] || (_cache[2] = [
              _createElementVNode("span", null, "Log ind", -1)
            ])))
      ])
    ])
  ]))
}
}

})